'use strict';

var stringify = require('./stringify');
var parse = require('./parse');
var formats = require('./formats');

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/qs/lib/index.js
// module id = 656
// module chunks = 0 1 2 3 4 5 6 7 8